var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { ENDPOINTS } from '../../../types/endpoints';
import { GaServiceHelpers } from './ga.service.helpers';
import { isClientSideRendering } from '../../utils/isClientSideRendering.utils';
import { urlUtils } from '../../utils/url.utils';
import { AmplitudeService } from './Amplitude.service';
import { Logger } from '../../utils/Logger';
var ROUTES_NAMES = (_a = {
        '/': 'MortgageRoute1'
    },
    _a[ENDPOINTS.MORTGAGE_ROUTE_1] = 'MortgageRoute1',
    _a[ENDPOINTS.REFERRAL_SCOPE] = 'MortgageRoute1',
    _a[ENDPOINTS.MORTGAGE_ROUTE_2] = 'ScoutMortgageRoute',
    _a[ENDPOINTS.MORTGAGE_ROUTE_3] = 'MortgageRoute3',
    _a[ENDPOINTS.MORTGAGE_ROUTE_4] = 'ImmoweltPage',
    _a[ENDPOINTS.MORTGAGE_ROUTE_5] = 'DrKleinPage',
    _a[ENDPOINTS.MORTGAGE_ROUTE_6] = 'Baufi24Page',
    _a[ENDPOINTS.MORTGAGE_ROUTE_7] = 'HypoFriendPage',
    _a[ENDPOINTS.MORTGAGE_ROUTE_8] = 'VergleichPage',
    _a[ENDPOINTS.MORTGAGE_ROUTE_9] = 'UrbyoPage',
    _a);
function getGTM() {
    window.smavaGoTaMa2016 = window.smavaGoTaMa2016 || [];
    return window.smavaGoTaMa2016;
}
function getCurrentRouteName() {
    var pathname = window.location.pathname;
    var pathnameScope = urlUtils.getPathnameScope(pathname);
    return ROUTES_NAMES.hasOwnProperty(pathnameScope)
        ? ROUTES_NAMES[pathnameScope]
        : null;
}
function pushEvent(event, meta) {
    getGTM().push(__assign({ event: event }, meta));
}
function shouldEmitNavigationEvent(isVirtualPage) {
    // do not emit event in case of route page, since virtual pages events,
    // that should be emitted later, will be treated as doubles
    var isRouteEndpoint = [ENDPOINTS.ROOT, ENDPOINTS.MORTGAGE_ROUTE_2].includes(window.location.pathname);
    return !isRouteEndpoint || isVirtualPage;
}
function getNavigationDataForPage() {
    var pathname = window.location.pathname;
    return ["/vp".concat(pathname), ''];
}
function getNavigationDataForVirtualPage(virtualPathName) {
    var pathname = window.location.pathname;
    var pathPrefix = pathname !== '/' ? pathname : '';
    return ["/vp".concat(pathPrefix).concat(virtualPathName), virtualPathName];
}
function pushNavigationEvent(path, step, meta) {
    var _a = window.location, search = _a.search, pathname = _a.pathname, hostname = _a.hostname, origin = _a.origin;
    var isVirtualPageEvent = step.length > 0;
    if (!shouldEmitNavigationEvent(isVirtualPageEvent)) {
        return;
    }
    pushEvent('virtual_page', {
        page: {
            breadCrumbs: {},
            code: 200,
            design: 'V1',
            embedded: 0,
            fullPath: "".concat(origin).concat(pathname),
            hostname: hostname,
            origin: origin,
            path: path,
            route: getCurrentRouteName(),
            siteArea: 'baufi.smava',
            step: step,
            title: window.document.title,
            url_parameters: search,
            version: 'V1',
        },
        experiments: GaServiceHelpers.mapGAMetaToExperimentResults(meta),
    });
    AmplitudeService.trackPage(step);
}
function pushLeadEvent(placementId, meta) {
    pushEvent('all_leads_cm', __assign({ affiliate: {
            placement_id: placementId,
        }, page: { route: getCurrentRouteName() }, loan: { status: 'lead' }, experiments: GaServiceHelpers.mapGAMetaToExperimentResults(meta) }, (meta.preferredChannel && { preferredChannel: meta.preferredChannel })));
    AmplitudeService.trackEvent('lead');
}
var isInitiated = false;
var preservedEvents = [];
function runPreservedEvents() {
    preservedEvents.forEach(function (preservedEvent) {
        Logger.debug('Flush preserved event:', preservedEvent.event);
        var method = GAService[preservedEvent.event];
        if (typeof method === 'function') {
            var args = preservedEvent.args;
            // Known limitation of TS2556: method should get EXACT tuple signature,
            // while exact preserved method is generic per all methods, like: "[] | [] | []"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            method.apply(void 0, args);
        }
    });
    preservedEvents = [];
}
// Service should be initialized once OneTrust consent has been evaluated.
// Any events came before init will be preserved in an array and envoked
// once again automatically, at the level of init method
export var GAService = {
    init: function (categories) {
        if (!isClientSideRendering()) {
            return;
        }
        // for the first time loading, when we are waiting for consent data from user
        if (categories === null) {
            return;
        }
        pushEvent('ConsentLevel', {
            ConsentPriority1: categories.performance,
            ConsentPriority2: categories.marketing,
        });
        Logger.debug('Initiated');
        isInitiated = true;
        runPreservedEvents();
    },
    onPageEnter: function (meta) {
        if (!isClientSideRendering()) {
            return;
        }
        if (!isInitiated) {
            preservedEvents.push({ event: 'onPageEnter', args: [meta] });
            return;
        }
        var _a = getNavigationDataForPage(), path = _a[0], step = _a[1];
        pushNavigationEvent(path, step, meta);
    },
    onVirtualPageEnter: function (virtualPathName, meta) {
        if (!isClientSideRendering()) {
            return;
        }
        if (!isInitiated) {
            preservedEvents.push({
                event: 'onVirtualPageEnter',
                args: [virtualPathName, meta],
            });
            return;
        }
        var _a = getNavigationDataForVirtualPage(virtualPathName), path = _a[0], step = _a[1];
        pushNavigationEvent(path, step, meta);
    },
    onLeadCreated: function (placementId, meta) {
        if (!isClientSideRendering()) {
            return;
        }
        if (!isInitiated) {
            preservedEvents.push({
                event: 'onLeadCreated',
                args: [placementId, meta],
            });
            return;
        }
        if (typeof placementId === 'undefined') {
            placementId = GaServiceHelpers.getPlacementIdFromSmavaCookies();
        }
        pushLeadEvent(placementId, meta);
    },
};
